export default __webpack_public_path__ + "static/media/hero-03.95f3deb9.png";